{

    "RegMM-Quick-Search-Fields": [
        {
            "label": "Symbol", "columnname": "Symbol", "placeholder": "Symbol",
            "width": "", "datatype": "String", "isLarge": false
        }
    ],
    "RegMM-Grid-Columns": [
        {
            "display": "true",
            "ui_columnname": "MPID",
            "db_columnname": "FirmMPID",
            "datatype": "String",
            "mappingkey": "FirmMPID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Symbol",
            "db_columnname": "Symbol",
            "datatype": "String",
            "mappingkey": "Symbol",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "ReportDate",
            "db_columnname": "ReportDate",
            "datatype": "String",
            "mappingkey": "ReportDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "CreatedDate",
            "db_columnname": "CreatedDate",
            "datatype": "String",
            "mappingkey": "CreatedDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "UpdatedDate",
            "db_columnname": "UpdatedDate",
            "datatype": "String",
            "mappingkey": "UpdatedDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "User",
            "db_columnname": "User",
            "datatype": "String",
            "mappingkey": "User",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        }
    ],
    "RegMM-Opted-Export-CSV-Grid-Columns": [
        {
            "columnName": "Symbol",
            "dbFieldValue": "symbol"
        },
        {
            "columnName": "mpid",
            "dbFieldValue": "mpid"
        },
        {
            "columnName": "reportDate",
            "dbFieldValue": "reportDate"
        },
        {
            "columnName": "User",
            "dbFieldValue": "updateUser"
        }
    ]
}